import * as React from 'react';

import type { IQuestIncentiveOfferFragment } from 'generated/sanity-graphql';
import { routes } from 'navigation/routing';
import { t } from 'state/intl/translations';
import { maybeLocaleImages } from 'utils/graphql';
import { blockContentToPlainText } from 'utils/sanity';

import { QuestItemIncentive } from './quest-item-incentive';

export const QuestOfferIncentive = ({
  cmsQuestOfferIncentive,
  loyaltyOfferId = '',
  onCloseDrawer,
}: {
  cmsQuestOfferIncentive: IQuestIncentiveOfferFragment;
  loyaltyOfferId?: string;
  onCloseDrawer: () => void;
}) => {
  const image = maybeLocaleImages(cmsQuestOfferIncentive.localizedImage);
  const name = blockContentToPlainText(cmsQuestOfferIncentive.name?.localeRaw);
  const link = `${routes.loyaltyOfferList}/${loyaltyOfferId}`;

  return (
    <QuestItemIncentive
      title={t('offer')}
      linkTo={link}
      image={image}
      altImage={name}
      name={name}
      onCloseDrawer={onCloseDrawer}
    />
  );
};
